import React, { useEffect, useState } from "react";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { useParams } from "react-router-dom";

window.Pusher = Pusher;

export default function LiveScoreboard({ eventId }) {
  const { event_id } = useParams();
  const activeEventId = eventId || event_id;
  const [scores, setScores] = useState({});

  useEffect(() => {
    if (!activeEventId) return;

    const echo = new Echo({
      broadcaster: "pusher",
      key: "local",
      cluster: "mt1",
      forceTLS: false
    });

    echo.channel(`event.${activeEventId}`)
        .listen(".score.updated", (e) => {
          setScores(prev => ({
            ...prev,
            [e.data.match_id]: e.data.score
          }));
        });

    return () => echo.disconnect();

  }, [activeEventId]);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">LIVE SCOREBOARD</h1>
      {!activeEventId ? (
        <p className="text-slate-600">Event not selected.</p>
      ) : null}

      {Object.keys(scores).length === 0 && activeEventId ? (
        <p className="text-slate-600">Waiting for live score updates...</p>
      ) : null}

      {Object.keys(scores).map(matchId => (
        <div key={matchId} className="bg-white border rounded-lg p-4 mb-3">
          <h3 className="font-semibold mb-2">Match #{matchId}</h3>
          {Object.entries(scores[matchId]).map(([team, pts]) => (
            <p key={team}>Team {team}: {pts}</p>
          ))}
        </div>
      ))}
    </div>
  );
}
